import {Typography} from '@mui/material';
import {emailRegexValidation, HomeEnum, MyPaymentsEnum, ProfileEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React, {Fragment, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {usePersonalData} from 'presentation/hooks';
import {CompleteProfileEnum} from 'main/analytics/gaTagsEnum';
import {validateCellPhone} from 'presentation/utils/validateCellPhone';
import {AlertActions} from '../AlertActions';
import {AlertModal} from '../AlertModal';
import {useSubscriptionDialogsStateStore} from '../SubscriptionDialogs/store/useSubscriptionDialogsStateStore';

const {
	headerTitle,
	title,
	defaultDescription,
	contactDescription,
	primaryAction,
	secondaryAction,
	invalidEmail,
	invalidEmailAndPhone,
	invalidPhone,
	cancel,
} = translations['pt-br'].privateFlow.refund.holderDataPage.modals.emptyInfosModal;

export function ModalCompleteYourProfile() {
	const {currentEmail, currentPhone} = usePersonalData();
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const setDialogs = useSubscriptionDialogsStateStore(state => state.updateState);
	const isUserInElectronicPaymentsPages =
		pathname === HomeEnum.HOME_PAGE || pathname === MyPaymentsEnum.OPEN_BILLS;

	const currentEmailIsInvalid = !emailRegexValidation.test(currentEmail || '');
	const currentPhoneIsInvalid = !validateCellPhone(currentPhone);
	const emptyContact = !currentEmail || !currentPhone;
	const shouldOpenModal = emptyContact || currentEmailIsInvalid || currentPhoneIsInvalid;

	const [open, setOpen] = useState(shouldOpenModal);
	const modalDescription = () => {
		if (emptyContact) {
			return (
				<Fragment>
					{contactDescription.part1}
					<b>{contactDescription.part2}</b> {contactDescription.part3}
				</Fragment>
			);
		}

		if (currentEmailIsInvalid) {
			if (currentPhoneIsInvalid) {
				return (
					<Fragment>
						{invalidEmailAndPhone.part1}
						<b>{invalidEmailAndPhone.part2}</b>
						{invalidEmailAndPhone.part3}
						<b>{invalidEmail.part4}</b>
					</Fragment>
				);
			}

			return (
				<Fragment>
					{invalidEmail.part1}
					<b>{invalidEmail.part2}</b>
					{invalidEmail.part3}
					<b>{invalidEmail.part4}</b>
				</Fragment>
			);
		}

		if (currentPhoneIsInvalid) {
			return (
				<Fragment>
					{invalidPhone.part1}
					<b>{invalidPhone.part2}</b>
					{invalidPhone.part3}
					<b>{invalidEmail.part4}</b>
				</Fragment>
			);
		}

		return null;
	};

	const handleSecondaryAction = () => {
		if (isUserInElectronicPaymentsPages) {
			setDialogs({
				isSubscriptionModalOpen: false,
			});
			setOpen(false);
		} else {
			navigate(HomeEnum.HOME_PAGE, {state: pathname});
		}
	};

	return (
		<AlertModal
			data-tag-id={CompleteProfileEnum.DV_VISUALIZOU_MODAL_AVISO}
			footerContent={
				<AlertActions
					flexDirection="column-reverse"
					primaryAction={() => navigate(ProfileEnum.PROFILE, {state: pathname})}
					secondaryAction={handleSecondaryAction}
					secondaryText={isUserInElectronicPaymentsPages ? cancel : secondaryAction}
					primaryText={primaryAction}
					dataTagId={CompleteProfileEnum.DV_CLICK_IR_PARA_PERFIL}
					secondaryBtnDataTagId={CompleteProfileEnum.DV_CLICK_VOLTAR_PARA_INICIO}
				/>
			}
			subDescription={
				<Typography component="span" textAlign="center">
					{modalDescription()}

					<br />
					{defaultDescription}
				</Typography>
			}
			headerTitle={headerTitle}
			title={title}
			open={isUserInElectronicPaymentsPages ? open : shouldOpenModal}
			variant="info"
			disableClose
		/>
	);
}
